export { default } from './Property';
